import React from 'react';
import { Switch, Route } from 'react-router-dom';
import LoginPage from '../components/login/LoginPage';
import PortalManager from '../components/Manager/PortalManager';
import SearchIdCouncil from '../components/Manager/SearchIdCouncil';
import Main from '../template/Main';
import { MainAppContext } from './MainAppProvider';
import TranslateProvider from './TranslationsProvider';
import Translate from '../template/TranslationsProvider';

export const RouterContext = React.createContext();

export const AppRouter = () => {
	const [state, toggle] = React.useState({
		menu: false
	});

	const toggleMenu = () => {
		toggle({
			...state,
			menu: !state.menu
		});
	};

	return (
		<>
			<RouterContext.Provider value={{
				...state,
				toggleMenu
			}}>
				<TranslateProvider>
					<Translate>
						<div style={{ display: 'flex', height: '100%' }}>
							<SubdomainApp />
						</div>
					</Translate>
				</TranslateProvider>
			</RouterContext.Provider>
		</>
	);
};

function SubdomainApp() {
	const mainAppContext = React.useContext(MainAppContext);

	const getLoggedApp = () => (
		<>
			{['root', 'devAdmin'].includes(mainAppContext.state.user.roles) ?
				<Switch>
					<Route exact path="/:name" component={Main} />
					<Route exact path="/" component={SearchIdCouncil} />
					<Route exact path="/rootportal/:id" component={PortalManager} />
					<Route component={SearchIdCouncil} />
				</Switch>
				:
				<div>No tienes permisos</div>
			}
		</>
	);
	const getNotLoggedApp = () => (
		<>
			<Switch>
				<Route exact path="/:name" component={Main} />
				<Route exact path="/" component={LoginPage} />
				<Route component={LoginPage} />
			</Switch>
		</>
	);

	return (
		<>
			{mainAppContext.state.user ?
				getLoggedApp()
				:
				getNotLoggedApp()
			}
		</>
	);
}


export default AppRouter;
